<template>
  <div>
    <v-sheet
      class="pa-1"
      color="rounded-tl-xl grey lighten-3"
      elevation="6"
    >
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <div
            class="pa-1 text-center blue-grey darken-1 state-title"
            style="min-height: 50px"
          >
            <!-- <div class="subtitle-1 white--text">
              {{ temperatureCurretStatus.targetDeviceTargetDescription }}
            </div> -->
            <div class="subtitle-1 white--text">
              <router-link
                v-if="temperatureCurretStatus.targetDeviceId"
                style="color: white"
                active-class="sensor-link"
                class="sensor-link"
                :to="{ name: 'temperatureview', params: { id: temperatureCurretStatus.targetDeviceId }}"
              >
                {{ temperatureCurretStatus.targetDeviceDescription }}
              </router-link>
            </div>
          </div>
          <h3 class="font-weight-bold blue--text">
            <v-icon class="icon-color">
              mdi-clock
            </v-icon>
            {{ temperatureCurretStatus.registerAt | formatLongDate }}
          </h3>
        </v-col>
      </v-row>
      <v-row
        dense
        justify="center"
      >
        <v-col
          cols="12"
          md="12"
        >
          <v-row
            no-gutters
          >
            <v-col>
              <v-card
                class="pa-1 ma-1 card-temperature"
                outlined
              >
                {{ $t('temperature-set.temperature') }}
              </v-card>
            </v-col>
            <v-col>
              <v-card
                class="pa-1 ma-1 card-termo"
                outlined
                :color="tempColor"
              >
                {{ thermoValue }}{{ thermometerScale }}
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="spacin-padding">
              <v-card
                class="pa-1 ma-1 card-temperature"
                outlined
              >
                <div class="title-temperature white--text">
                  {{ temperatureCurretStatus.min }}{{ thermometerScale }}
                </div>
                {{ $t('temperature-set.min') }}
              </v-card>
            </v-col>
            <v-col>
              <v-card
                class="pa-1 ma-1 card-termo"
                outlined
              >
                <div class="title-temperature white--text">
                  {{ temperatureCurretStatus.max }}{{ thermometerScale }}
                </div>
                {{ $t('temperature-set.max') }}
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
  import mqtt from 'mqtt'
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const temperaturesRespository = repositoryFactory.get('temperatures')

  export default {
    name: 'TemperatureMiniStateView',
    mixins: [filters],
    props: {
      targetDeviceId: {
        type: String,
        required: true,
      },
      targetDeviceCode: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        thermometerScale: '',
        thermoValue: 0,
        temperatureCurretStatus: {
          targetDevice: {},
        },
        showErrorMessage: false,
        errorMessage: '',
        polling: null,
        connection: {
          host: 'mqtt.multisensores.com',
          port: 8084,
          endpoint: '/mqtt',
          clean: true, // Reserved session
          connectTimeout: 4000, // Time out
          reconnectPeriod: 4000, // Reconnection interval
          // Certification Information
          clientId: 'mini_view_temp',
          username: 'mini_view_temp_user',
          password: 'mini_view_temp_pass',
        },
        subscription: {
          topic: 'terrapez/frontend/cuarto1/micro1/',
          qos: 0,
        },
        receiveNews: '',
        client: {
          connected: false,
        },
      }
    },
    computed: {
      tempColor () {
        if (this.thermoValue > this.temperatureCurretStatus.max) {
          return 'red'
        } else {
          return this.thermoValue < this.temperatureCurretStatus.min ? 'blue' : '#8BC34A'
        }
      },
    },
    mounted () {
      var self = this
      if (self.targetDeviceId) {
        self.fetchData(self.targetDeviceId)
        // self.polling = setInterval(function () { self.fetchData(self.targetDeviceId) }, 0.5 * 60 * 1000)
      }
      this.createConnection()
    },
    beforeDestroy () {
      // clearInterval(this.polling)
    },
    methods: {
      fetchData (targetDeviceId) {
        var self = this

        temperaturesRespository.getCurrent(targetDeviceId).then(response => {
          self.temperatureCurretStatus = response.data.data
          self.thermometerScale = self.temperatureCurretStatus.isFahrenheit ? '°F' : '°C'
          self.thermoValue = self.temperatureCurretStatus.isFahrenheit ? self.temperatureCurretStatus.fahrenheit : self.temperatureCurretStatus.celsius
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
      // Create connection
      createConnection () {
        // Connect string, and specify the connection method used through protocol
        // ws unencrypted WebSocket connection
        // wss encrypted WebSocket connection
        // mqtt unencrypted TCP connection
        // mqtts encrypted TCP connection
        // wxs WeChat mini app connection
        // alis Alipay mini app connection
        this.connection.clientId = 'mini_view_temp_' + Math.round(Math.random() * (0 - 10000) * -1)
        var self = this
        const { host, port, endpoint, ...options } = this.connection
        const connectUrl = `wss://${host}:${port}${endpoint}`
        try {
          this.client = mqtt.connect(connectUrl, options)
        } catch (error) {
          console.log('mqtt.connect error', error)
        }
        this.client.on('connect', () => {
          console.log('Connection succeeded!')
          self.doSubscribe()
        })
        this.client.on('error', error => {
          console.log('Connection failed', error)
        })
        this.client.on('message', (topic, message) => {
          // console.log(`Received message ${message.toString()} from topic ${topic}`)
          self.receiveNews = JSON.parse(message.toString())
          self.thermoValue = self.receiveNews.temperature
          self.temperatureCurretStatus.registerAt = self.receiveNews.registerAt
        })
      },
      doSubscribe () {
        console.log('terrapez/frontend/' + this.targetDeviceCode + '/view', 'test')
        const { qos } = this.subscription
        this.client.subscribe('terrapez/frontend/' + this.targetDeviceCode.toLowerCase() + '/view', { qos }, (error, res) => {
          if (error) {
            console.log('Subscribe to topics error', error)
            return
          }
          console.log('Subscribe to topics res', res)
        })
      },
    },
  }
</script>
<style>
.no-gutters {
    margin-right: 0;
    margin-left: 0;
    margin-bottom: 0px;
}
.m-botom{
    margin-right: 0;
    margin-left: 0;
    margin-bottom: -20px !important;
}
.v-application .blue-grey.darken-1 {
    background-color: #023A66 !important;
    border-color: #023A66 !important;
}
.v-application .blue--text{
  color: #023A66 !important;
  caret-color: #023A66 !important;
  text-align: center !important;
}
.icon-color{
  color: #339999 !important;
}
.card-temperature{
  background-color: #023A66 !important;
  border-color: #023A66 !important;
  color: #E2AA12 !important;
  text-align: center !important;
}
.card-termo{
  background-color: #339999 !important;
  border-color: #339999 !important;
  color: #FFFFFF !important;
  text-align: center !important;
}
.title-temperature{
  font-size: 1rem !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Roboto", sans-serif !important;
}
.spacin-padding{
    padding: 0 0 0 0;
}
@media only screen and (max-width: 700px) {
  .spacin-padding{
    padding: 0 22px 0 0 !important;
  }
}
</style>
<style lang="sass" scoped>
 .state-title
   height: 45px

 .sensor-link a
   color: white

</style>
